import { committeeMemberDeleteApi } from "../../api/committeeMember/committeeMemberDeleteApi"

type PayloadShape = Parameters<typeof committeeMemberDeleteApi>[0]

export async function committeeMemberDeleteService(payload: PayloadShape, token: string) {
	return await committeeMemberDeleteApi(payload, token)
}
